import { put, takeLatest, select, call } from 'redux-saga/effects'
import { createInterviewRequest } from '@/core/apiModules/interviewRequest'
import { currentUser } from '@/core/selectors/currentUser'
import { candidatesModule } from '@/CandidateListES/redux/modules'
import { interviewRequestModule } from '../modules'
import { candidateDetails } from '../selectors/candidateDetails'
import { competingInterviewRequests } from '../selectors/competingInterviewRequests'
import { getPositions } from '../selectors/positions'
import { trackInterviewRequestSubmissionSuccess } from '../../helpers/analyticsHelpers'
import { currentHiringTeam } from '@/core/selectors/sessions'

export function* create(props) {
  const {
    payload: {
      hiring_teams_id: hiringTeamsId,
      isRecommendedCandidate,
      data: { messageSameAsTemplate, candidateHasConvertedSalary, ...data },
    },
  } = props
  yield put(interviewRequestModule.toggleCreating(true))

  try {
    const { result } = yield call(createInterviewRequest, hiringTeamsId, data)
    yield put(
      interviewRequestModule.createSuccess({
        ...result,
        member_profile_name: result.from,
      }),
    )

    // Push the change to the candidate list in the background
    const user = yield select(currentUser)

    yield put(
      candidatesModule.updateFromDetails({
        hiring_team_id: result.hiring_team_id,
        id: result.candidate.id,
        member_profile_id: user.id,
        member_profile_name: user.name,
      }),
    )

    const candidate = yield select(candidateDetails)
    const competingIRs = yield select(competingInterviewRequests)
    const positions = yield select(getPositions)
    const hiringTeam = yield select(currentHiringTeam)

    yield call(props.resolve, result)

    trackInterviewRequestSubmissionSuccess({
      candidate,
      competingIRs,
      positions,
      interviewRequest: result,
      messageSameAsTemplate,
      hiringTeam,
      candidateHasConvertedSalary,
      workplacePolicy: data.workplace_policy,
      isRecommendedCandidate,
    })
  } catch (err) {
    yield call(props.reject, err?.response?.data?.message)
  }

  yield put(interviewRequestModule.toggleCreating(false))
  yield put(interviewRequestModule.toggleShowForm(false))
}

export default function* watchInterviewRequestsSaga() {
  yield takeLatest(interviewRequestModule.CREATE, create)
}
